import TokenService from '../../services/TokenService'

export default function authentication({ router, next }) {
    const loggedIn = !!TokenService.getToken();

    if (!loggedIn) {
        return router.push({ name: 'SignIn' });
    }

    return next();
}